import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from "vue";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FormRow',
  props: {
    centerFields: { type: Boolean },
    withThreeColumns: { type: Boolean },
    withFourColumns: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const display = computed(() => {
  let classes = "form__row";

  if (props.centerFields) classes += ' align-center'
  if (props.withFourColumns) classes += ' quadruple'
  if (props.withThreeColumns) classes += ' triple'

  return classes
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(display.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})